import { enderecoStep, DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL } from '../../shared/enderecoSections';
import { termosStep } from '../../shared/termosSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';

const pedidoCancelamentoConfig = {
  id: 'pedido_cancelamento',
  nome: 'Cancelamento de Inscrição',
  categoria: 'pedidos',
  descricao: 'Solicitação de cancelamento de inscrição na OAB/MS',
  icon: 'FaTrashAlt',

  documentConfig: {
    required: [
      { 
        id: 'requerimento', tipoDocumentoProcesso: 433, 
        name: 'Requerimento', 
        description: 'Requerimento de cancelamento preenchido e assinado digitalmente', 
        required: true 
      }
    ],

    optional: [
      { 
        id: 'documentacaoComprobatoria', tipoDocumentoProcesso: 473,
        name: 'Documentação Comprobatória', 
        description: 'Caso o cancelamento seja por motivo de incompatibilidade ou outros previstos em lei, anexe o documento comprovante.',
        required: false 
      }
    ],

    conditional: []
  },

  paymentConfig: {
    amount: 77.00
  },

  protocoloConfig: {
    modeloRequerimento: '200',
    tiposAssunto: '656',
    tipoPedido: '486'
  },

  dadosRequerimentoConfig: mergeDadosRequerimentoConfig(
    {
      campos: [
        { field: 'nomeCompleto', campoNome: 'Nome' },
        { field: 'cpf', campoNome: 'CPFCNPJ' }
      ]
    },
    DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL
  ),

  tituloConfig: {
    tipoLancamentoId: 78,
    enderecoOrigem: 'residencial'
  },

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { 
              type: 'text', 
              name: 'nomeCompleto', 
              label: 'Nome completo', 
              required: true, 
              placeholder: 'Digite seu nome completo' 
            },
            { 
              type: 'cpf', 
              name: 'cpf', 
              label: 'CPF', 
              required: true 
            }
          ]
        }
      ]
    },
    enderecoStep({ autoCep: true }),
    termosStep()
  ]
};

export default pedidoCancelamentoConfig;